/**
 * Endpoint catalog. Phase 0: placeholder with one health probe.
 * Phase 1: register /auth/* + /users/me.
 * Phase 2: register /memories/* + presigned upload helpers.
 * Phase 3: register /albums/* + invite flows.
 *
 * Centralizing URLs here keeps components from scattering string literals.
 */

export const endpoints = {
  health: "/healthz", // unversioned, but listed for convenience
  auth: {
    register: "/auth/register",
    login: "/auth/login",
    refresh: "/auth/refresh",
    logout: "/auth/logout",
  },
  wechat: {
    authorize: "/auth/wechat/authorize",
    callback: "/auth/wechat/callback",
    bind: "/auth/wechat/bind",
    unbind: "/auth/wechat/unbind",
    jsapiSignature: "/auth/wechat/jsapi-signature",
  },
  users: {
    me: "/users/me",
    storage: "/users/me/storage",
    avatar: "/users/me/avatar",
    update: "/users/me",
    delete: "/users/me",
    password: "/users/me/password",
    phoneSendCode: "/users/me/phone/send-code",
    phoneVerify: "/users/me/phone/verify",
  },
  memories: {
    list: "/memories",
    create: "/memories",
    detail: (id: string) => `/memories/${id}`,
    update: (id: string) => `/memories/${id}`,
    delete: (id: string) => `/memories/${id}`,
    uploadUrl: (id: string) => `/memories/${id}/media/upload-url`,
    confirmMedia: (id: string) => `/memories/${id}/media`,
    deleteMedia: (id: string, mediaId: string) => `/memories/${id}/media/${mediaId}`,
    downloadUrl: (id: string, mediaId: string, variant?: "thumbnail" | "thumbnail_hd" | "full") => {
      const base = `/memories/${id}/media/${mediaId}/download-url`;
      return variant ? `${base}?variant=${variant}` : base;
    },
  },
  albums: {
    list: "/albums",
    create: "/albums",
    detail: (id: string) => `/albums/${id}`,
    update: (id: string) => `/albums/${id}`,
    delete: (id: string) => `/albums/${id}`,
    // 修改自己在此相册的显示名（不影响相册原名，仅自己可见）。
    me: (id: string) => `/albums/${id}/me`,
    members: (id: string) => `/albums/${id}/members`,
    invites: (id: string) => `/albums/${id}/invites`,
    join: "/albums/join",
    memories: (id: string) => `/albums/${id}/memories`,
  },
  shared: {
    list: "/shared",
    new: "/shared/new",
    detail: (id: string) => `/shared/${id}`,
    join: "/shared/join",
  },
  notifications: {
    list: "/notifications",
    unreadCount: "/notifications/unread-count",
    read: (id: string) => `/notifications/${id}/read`,
    readAll: "/notifications/read-all",
  },
  geocode: {
    mapKey: "/geocode/map-key",
  },
} as const;
